import React from 'react'
import { CardMedia, Skeleton } from '@mui/material'
import { Box } from '@mui/system'
import DefaultEventImage from '../../../../assets/images/DefaultEventImage.png'
import { fontSizes, fontWeights } from '../../../Common/Typography/TypographyStyles'
import { useFetchImageUrl } from '../../../../hooks/componentHooks/useFetchImageUrl'
import { textColors } from '../../../Common/Color/Color'

interface CardImageProps {
  eventData: {
    imageFilename: string
    title: string
  }
}

const CardImageSkeleton = () => {
  return (
    <>
      <Skeleton
        variant='rectangular'
        sx={{ height: { xs: 140, sm: 170, md: 200 }, mb: 1 }}
        animation='wave'
      />
    </>
  )
}

const CardImage: React.FC<CardImageProps> = ({ eventData }) => {
  const { imageUrl, loading } = useFetchImageUrl(
    'images',
    eventData.imageFilename,
    'event',
    Boolean(eventData),
  )

  return (
    <Box position='relative' sx={{ height: { xs: 140, sm: 170, md: 200 }, overflow: 'hidden' }}>
      {loading ? (
        <CardImageSkeleton />
      ) : (
        <CardMedia
          component='img'
          image={!imageUrl ? DefaultEventImage : imageUrl}
          height='100%'
          alt='event-card-preview'
          sx={{ objectFit: 'cover', zIndex: 0 }}
        />
      )}
      <Box
        position='absolute'
        top={0}
        left={0}
        right={0}
        bottom={0}
        p={2}
        sx={{
          display: 'flex',
          justifyContent: 'start',
          alignItems: 'end',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          opacity: 1,

          color: textColors.white,
          fontSize: fontSizes.size14,
          fontWeight: fontWeights[700],
        }}
      >
        {eventData.title}
      </Box>
    </Box>
  )
}

export default CardImage
